export enum LicenseView {
  BROWSE = 1,
  USER_DETAIL = 2,
  OVERVIEW = 3,
  TRAININGS = 4,
  ADD = 5,
  TRAINING_DETAIL = 6,
  TRAINING_EDIT = 7,
}
